import treeView from './treeView.vue';

export default treeView;
